import { Multimedia } from '@web/shared/module/multimedia';
import { Guid, Nillable } from '@web/utils';

export class AdminBrandBannerPreviewItem {
  public constructor(
    public readonly id: Guid,
    public readonly file: Multimedia,
    public readonly url?: Nillable<string>,
  ) {}
}
